module.exports = __webpack_public_path__ + "img/bandeira-brasil.212aea2e.svg";